import { createContext } from 'react';
import {
  type SegmentedButtonsProps,
  type SegmentedButtonsProviderProps,
} from '../types/segmentButtons';
import { useSegmentedButtonsActiveIndex } from '../hooks/useSegmentedButtonsActiveIndex';

export const SegmentedButtonsProvider = (props: SegmentedButtonsProviderProps) => {
  const { children } = props;

  const useActiveIndex = useSegmentedButtonsActiveIndex({
    value: props.selectedValue ?? '',
    onChange: props.onChange,
  });

  return (
    <SegmentedButtonsContexts.props value={props}>
      <SegmentedButtonsContexts.useCurrentIndex value={useActiveIndex}>
        {children}
      </SegmentedButtonsContexts.useCurrentIndex>
    </SegmentedButtonsContexts.props>
  );
};

export const SegmentedButtonsContexts = {
  props: createContext<SegmentedButtonsProps>({
    selectedValue: '',
    onChange: () => {
      throw new Error(
        'No SegmentedButtonsProvider found, please wrap <SegmentedButtonsProvider> around your component',
      );
    },
    items: [],
  }),
  useCurrentIndex: createContext<ReturnType<typeof useSegmentedButtonsActiveIndex>>({
    selectedValue: '',
    setSelectedValue: () => {
      throw new Error(
        'No SegmentedButtonsProvider found, please wrap <SegmentedButtonsProvider> around your component',
      );
    },
    onChange: () => {
      throw new Error(
        'No SegmentedButtonsProvider found, please wrap <SegmentedButtonsProvider> around your component',
      );
    },
  }),
};
